// const BASE_URLL = "https://ayatascloud.com/api/";
const BASE_URL = "https://realtyapp.realtyitsolutions.com/api/";

export const PROPERTIES_URL = BASE_URL + "propertieslist";
export const PROPERTY_DETAIL_URL = BASE_URL + "propertydetails/";
export const ADD_PROPERTY_URL = BASE_URL + "saveproperty/";
// export const PROPERTY_DETAIL_URL = BASE_URL + "deleteproperty/";
export const LOGIN_URL = BASE_URL + "login";
export const LOGOUT_URL = BASE_URL + "logout";
export const SEARCH_URL = BASE_URL + "propertysuggestions";
export const CREATE_LEAD_URL = BASE_URL + "savecontactagent/";
export const DELETECONTACTAGENT_URL = BASE_URL + "deletecontactagent/";
export const CONTACTAGENTDETAIL_URL = BASE_URL + "contactagentdetails";
export const CONTACTAGENTLIST_URL = BASE_URL + "contactagentlist";
export const TOURREQUESTLIST_URL = BASE_URL + "tourrequestlist";
export const AGENT_LIST_URL = BASE_URL + "agentlist";

export const TASK_LIST_URL = BASE_URL + "tasklist";
export const CREATE_TASK_URL = BASE_URL + "savetask/";
export const DELETE_TASK_URL = BASE_URL + "deletetask/";
// gettask/{id}
// deletetask/{id}
// getproperty/id

export const events = [
  {
    title: "Meeting with Bob",
    message:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
    doctor: "Dr. Smith",
    location: "Room 101",
    start: new Date(),
    end: new Date(),
  },
  {
    title: "Meeting with Bob",
    message: "Discuss project milestones and next steps",
    doctor: "Dr. Smith",
    location: "Room 102",
    start: new Date(),
    end: new Date(),
  },
  {
    title: "Meeting with Bob",
    message:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
    doctor: "Dr. Smith",
    location: "Room 103",
    start: new Date(),
    end: new Date(),
  },
  {
    title: "Meeting with Bob",
    message: "Discuss project milestones and next steps",
    doctor: "Dr. Smith",
    location: "Room 104",
    start: new Date("2025-08-30T10:45:00"),
    end: new Date("2025-08-30T11:00:00"),
  },
  {
    title: "Meeting with Bob",
    message:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ",
    doctor: "Dr. Smith",
    location: "Room 105",
    start: new Date(),
    end: new Date(),
  },
  {
    title: "MRI Registration",
    start: new Date(),
    end: new Date(),
  },
  {
    title: "ENT Registration",
    start: new Date(),
    end: new Date(),
  },
];
